// End of run summary: the time and the checkpoint splits.

import { bindLabel } from '../../game/binds';
import type { RunResult } from '../../game/game';
import { formatTime } from '../../game/settings';
import { useApp } from '../context';
import { settings } from '../state';
import { Button } from './Button';

export function RunResultCard({ result, onClose }: { result: RunResult; onClose?: () => void }) {
  const app = useApp();
  const binds = settings.value.binds;
  return (
    <div class="run-result">
      <div class="run-result-head">
        <span class="eyebrow">{result.run === 'default' ? 'Run finished' : result.run}</span>
      </div>
      <div class="run-result-time mono">{formatTime(result.time)}</div>
      {result.splits.length > 0 && (
        <table class="splits-table">
          <thead>
            <tr>
              <th>CP</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {result.splits.map((s) => (
              <tr key={s.index}>
                <td>{s.index + 1}</td>
                <td class="mono">{s.time === null ? '—' : formatTime(s.time)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div class="run-result-actions">
        <Button variant="primary" size="sm" icon="restart" hint={bindLabel(binds, 'respawn')} onClick={() => app.restartRun()}>
          Restart
        </Button>
        <Button variant="secondary" size="sm" icon="eye" hint={bindLabel(binds, 'replay')} disabled={!result.replay} onClick={() => app.watchReplay()}>
          Watch replay
        </Button>
        {onClose && (
          <Button variant="ghost" size="sm" onClick={onClose}>
            Close
          </Button>
        )}
      </div>
    </div>
  );
}
